/**
 * The upstream source returns the status as a string ("status": "1"), so the value may arrive
 * either as a number or as a numeric string depending on how the backend passes it through.
 */
export function toInteger(rawValue) {
  if (typeof rawValue !== 'number' && typeof rawValue !== 'string') {
    return null;
  }

  const value = Number(rawValue);

  return Number.isInteger(value) ? value : null;
}

/**
 * The upstream codes are lower case, while the external id is typed by hand in the product settings
 * and in the answer rows, so it arrives in whatever case the CMS user used ("Zahlungsverkehr_Girokonto_Business").
 * Matching the raw strings silently misses those products, which is indistinguishable from "the customer
 * does not own it", so both sides are folded to lower case and trimmed before the lookup.
 */
export function normalizeExternalId(externalId) {
  return typeof externalId === 'string' ? externalId.trim().toLowerCase() : null;
}

export function getProductStatus(productStatuses, externalId) {
  const status = toInteger(productStatuses?.[normalizeExternalId(externalId)]);

  if (status === null || status <= 0) {
    return null;
  }

  return status;
}
